import React, {FC} from 'react';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  components: any[];
}

export const Compose: FC<Props> = ({components, children}) => (
  <>
    {components.reverse().reduce((acc, curr) => {
      const [Provider, props] = Array.isArray(curr) ? [curr[0], curr[1]] : [curr, {}];
      return <Provider {...props}>{acc}</Provider>;
    }, children)}
  </>
);
